// extracted by mini-css-extract-plugin
module.exports = {"container":"HistoryManagementFilters_container__22_zw","select":"HistoryManagementFilters_select__2XsbJ"};